import moment from 'moment';

export const formatDate = (date) => {
    let formattedDate = 'none';
    try {
        formattedDate = moment(date).format('MM/DD/YYYY');
    } catch (e) {
        console.log('error while formatting date ', e);
        formattedDate = 'none'
    }
    return formattedDate;
}

// Custom sort and label for search results
export const customSortResults = (options, searchTerm) => {
    const term = (searchTerm || '').toLowerCase();
    const sorted = [...options].sort((a, b) => {
        const aLabel = (a.groupId || a.code || '').toLowerCase();
        const bLabel = (b.groupId || b.code || '').toLowerCase();
        const aStarts = aLabel.startsWith(term);
        const bStarts = bLabel.startsWith(term);
        if (aStarts && !bStarts) return -1;
        if (!aStarts && bStarts) return 1;
        const aIncludes = aLabel.includes(term);
        const bIncludes = bLabel.includes(term);
        if (aIncludes && !bIncludes) return -1;
        if (!aIncludes && bIncludes) return 1;
        return 0;
    });
    return sorted.map((item, idx) => ({
        ...item,
        customLabel: `${item.groupId || item.code} - Result returned ${['first', 'second', 'third'][idx] || `${idx + 1}th`}`
    }));
};

/* export const tenantList = [
    {value: '938125692074', label: "bcbsal", displayName: "BCBS Alabama", env: ["dev", "qa", "stage", "stage-us", "pacheck", "pacheck-us"] },
    {value: '803297324478', label: "bcbsmn", displayName: "Blue Cross and Blue Shield of Minnesota", env: ["qa", "stage", "stage-us", "pacheck", "pacheck-us"]},
    {value: '822452986379', label: "bcbsmnuat", displayName: "BCBSMN UAT", env: ["dev"]},
    {value: '822447021638', label: "bcbsnd", displayName: "BCBS ND", env: ["dev", "qa", "stage", "stage-us", "pacheck", "pacheck-us"]},
    {value: '822481372605', label: "parkland", displayName: "BCBS Parkland", env: ["dev", "stage-us", "pacheck-us"]},
    // {value: '822481372605', label: "bcbspl", displayName: "BCBS Parkland", env: ["qa"]},
    {value: '822493540271', label: "bcbswy", displayName: "Blue Cross and Blue Shield of Wyoming", env: ["qa", "stage", "stage-us", "pacheck", "pacheck-us"]},
    {value: '912493540380', label: "coxh", displayName: "Cox Health", env: ["dev", "stage-us", "pacheck-us"]},
    {value: '922493540491', label: "pwest", displayName: "PWest", env: ["stage-us", "pacheck-us"]},
    {value: '933493540519', label: "jhopkins", displayName: "Johns Hopkins", env: ["stage-us", "pacheck-us"]},
    {value: '951493540402', label: "bcbsa", displayName: "BCBS Association", env: ["dev", "stage-us", "pacheck-us"]},
    {value: '951484651513', label: "smn", displayName: "State of Minnesota", env: ["stage-us", "pacheck-us"]},
    {value: '951485742624', label: "smt", displayName: "Samaritan Health Plans", env: ["stage-us", "pacheck-us"]},
    {value: '951495562624', label: "scha", displayName: "South Country Health Alliance", env: ["stage-us", "pacheck-us"]},
    {value: '953627784738', label: "ihp", displayName: "Itasca Health Plan", env: ["dev", "qa", "stage-us", "pacheck-us"]},
    {value: '973373889595', label: "raxis", displayName: "Raxis Testing Tenant", env: ["stage", "stage-us"]},
    {value: '916626113100', label: "iht", displayName: "IHT", env: ["stage-us"]}
]; */